import React from "react";

const NotFound = () => (
    <div>
    <section id="notFound" className="py-5">
      <div className="container text-center">
        <h1>Page introuvable</h1>

        <h2 className="section-title">Que cherchez-vous ?</h2>

        <p>Vous cherchez un local ou des bureaux ? Voux êtes au bon endroit.</p>
        <a href="/">Cliquer ici pour trouver une location de bueeaux à Villiers le Bel</a>
    </div>
    </section>
    </div>
);

export default NotFound;